import Modal from "./modal";
import AjaxForm from "../ajax-form";


class ModalForm extends Modal {
    static get events() {
        return {
            ...Modal.events,
            submit: "modal.form.events.submit",
            error: "modal.form.events.error",
            reset: "modal.form.events.reset"
        };
    }

    _initDOM(element) {
        let nodes = super._initDOM(element);

        let form = nodes.element.querySelector('form');
        let submit = form.querySelector('[type="submit"]');

        return {
            ...nodes, form, submit
        };
    }

    _init() {
        super._init(); 

        this.form = new AjaxForm(this.nodes.form, this.config);
    }

    reset() {
        this.nodes.form.reset();
    }
}

export default ModalForm;